export interface ProgramCardInterface {
  id: string;
  name: string;
  enabled: boolean;
  programId?: string;
  cardId?: string;
}

export class ProgramCard implements ProgramCardInterface {
  id: string;
  name: string;
  enabled: boolean;
  programId?: string;
  cardId?: string;

  constructor(data: Partial<ProgramCardInterface>) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.enabled = data.enabled || false;
    this.programId = data.programId;
    this.cardId = data.cardId;
  }

  toJson(): ProgramCardInterface {
    return {
      id: this.id,
      name: this.name,
      enabled: this.enabled,
      programId: this.programId,
      cardId: this.cardId,
    };
  }
}
